import styled, { css } from "styled-components";

export const StyledRadioWrapper = styled.div`
  padding: 12px 0;

  > span.label {
    color: var(--neutrals-text, var(--Color-neutral-700, #100a27));
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
    margin-bottom: 16px;
    display: block;
  }

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
    padding-bottom: 4px;
  }

  > div {
    display: flex;
    gap: 24px;
    flex-direction: ${({ $vertical }) => ($vertical ? "column" : "row")};

    ${({ $error }) =>
      $error &&
      css`
        > div > label > span.checkmark {
          border-color: ${({ theme }) => theme.colors.offTrackText};
          box-shadow: 0 0 20px 0px ${({ theme }) => theme.colors.offTrackText};
        }
      `}
  }

  input[type="radio"] {
    width: 0;
  }
`;
